<template>
    <Layout>
        <app-head title="Welcome" />
<!--        <h1>Ongestoord sporten op je eigen eiland</h1>-->
<!--        <p>-->
<!--            Stuur ons een bericht, of laat je nummer achter - dan nemen we contact met je op.<br/>-->
<!--            Ongestoord sporten op je eigen eiland! Hoe dat werkt, leggen we dan kort uit.<br/>-->
<!--            Past het Private Gym concept bij jou? Dan plannen we een rondleiding aan de Smedenstraat 286.-->
<!--        </p>-->

<!--        <form action="/contact" method="POST">-->
<!--            <label for="name">Naam:</label><br/>-->
<!--            <input v-model="name" type="text" id="name" name="name"><br/>-->
<!--            <label for="phone">Telefoonnummer:</label><br/>-->
<!--            <input v-model="phone" type="tel" id="phone" name="phone"><br/>-->
<!--            <p>-->

<!--            </p>-->
<!--            <input type="submit" value="Verstuur" @click.prevent="send">-->
<!--        </form>-->

<!--        <p>-->
<!--            {{ name }}<br/> {{ email }}<br/> {{ phone }}-->
<!--        </p>-->

            <div class="col-lg-4 col-10 mx-auto">
                <div class="px-6 pt-5 mt-5">
                    <img class="d-block mx-auto mb-3 w-100" src="/images/pg-logo-wide-s.png" alt="Private Gym Logo">
                    <h1 class="display-8 fw-bold">Ongestoord trainen op je eigen krachthonk vanaf €39,95 / 4 weken</h1>
                    <div class="mx-auto">
                        <p class="lead mb-4">
                            Meer informatie over het nieuwste fitness concept van Deventer?
                            Stuur een Whatsapp bericht, of laat je nummer achter, en kom even kijken.
                        </p>
                        <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-0  border-bottom border-top py-4">
                            <a type="button" class="btn btn-dark btn-lg px-4 me-sm-3 col-sm-6" @click.prevent="showFormModal = true">
                                <i class="bi bi-telephone-fill" style="margin-right: 12px;"></i>
                                Bellen
                            </a>
                            <a type="button" class="btn btn-success btn-lg px-4 col-sm-6" href="https://wa.me/+31649672871?text=Ik%20zou%20graag%20wat%20meer%20informatie%20willen%20over%20Private%20Gym%20%F0%9F%92%AA" rel="_blank">
                                <i class="bi bi-whatsapp" style="margin-right: 12px;"></i>
                                <span style="display: inline-block;">
                                    WhatsApp
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="overflow-hidden" style="max-height: 50vh;">
                <div class="container px-3" style="text-align: right !important;">
                    <img src="/images/rack-render-alpha.png" class="img-fluid rounded-3 mb-4" alt="Example image" width="700" height="500" loading="lazy">
<!--                    <img src="/images/pg-logo-s.png" class="img-fluid border rounded-3 shadow-lg mb-4" alt="Example image" width="700" height="500" loading="lazy">-->
<!--                    <img src="/images/pg-logo-s.png" alt="Private Gym Beeldmerk" style="-->
<!--                                        position: relative;-->
<!--                                        height: 784px;-->
<!--                                        float: right;-->
<!--                                        right: -210px;-->
<!--                                        bottom: -330px;-->
<!--                                        opacity: 0.025; z-index: 1"/>-->
            </div>
        </div>

        <div v-if="showFormModal">
            <div class="modal fade show" tabindex="-1" aria-modal="true" role="dialog" style="display: block;">
                <div class="modal-dialog modal-fullscreen-sm-down modal-dialog-centered">
                    <div class="modal-content" v-click-outside="closeModal" style="overflow:hidden;">
                        <div class="modal-body">
                            <form class="p-4 p-md-3 rounded-3">
                                <div class="form-floating mb-3">
                                    <input v-model="name" type="text" id="name" name="name" class="form-control">
                                    <label for="name">Naam</label>
                                </div>
                                <div class="form-floating mb-3">
                                    <input v-model="phone" type="tel" id="phone" name="phone" class="form-control">
                                    <label for="phone">Telefoonnummer</label>
                                </div>
                                <div class="alert alert-success" role="alert" v-if="sendSuccess">
                                    <i class="bi bi-check-circle-fill"></i> Gelukt! Tot snel
                                </div>
                                <div class="alert alert-danger" role="alert" v-if="errors.length">
                                    <i class="bi bi-x-circle-fill" style="margin-right: 4px;"></i> Whoops
                                    <ul class="errors mb-0">
                                        <li v-for="message in errors">{{ message }}</li>
                                    </ul>
                                </div>
                                <button @click.prevent="send" class="w-100 btn btn-lg btn-success" type="submit">
                                    <i class="bi bi-chevron-right" style="margin-right: 12px;" v-if="!loading"></i>
                                    <span class="spinner-border" role="status" v-if="loading"
                                      style="height: 1rem;
                                        width: 1rem;
                                        vertical-align: 0; margin-right: 12px;">
                                        <span class="visually-hidden">Loading...</span>
                                    </span>
                                    Verstuur
                                </button>
                                <hr class="my-4">
                                <small class="text-muted">
                                    <em>We nemen binnen 24 uur contact met je op</em>
                                    <img src="/images/pg-logo-s.png" alt="Private Gym Beeldmerk" style="    position: absolute;
                                        height: 84px;
                                        float: right;
                                        right: -10px;
                                        bottom: -30px;
                                        opacity: 0.25;">
                                </small>
                            </form>
                        </div>
    <!--                    <div class="modal-footer">-->
    <!--                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>-->
    <!--                    </div>-->
                    </div>
                </div>
            </div>
            <div class="modal-backdrop fade show"></div>
        </div>



    </Layout>
</template>

<script>
import Layout from '../../Components/Layout'
import AppHead from "../../Components/AppHead";
import axios from "axios";
import vClickOutside from 'click-outside-vue3'

export default {
    components: {
        AppHead,
        Layout,
    },
    props: {
        user: Object,
    },
    data() {
        return {
            name: '',
            email: '',
            phone: '',

            loading: false,

            showFormModal: false,
            sendSuccess: false,
            errors: [],
        }
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    methods: {
        send() {
            const vm = this;
            this.loading = true;
            this.errors = [];

            axios.post('/contact', {
                name: this.name,
                phone: this.phone,
            })
            .then(function (response) {
                vm.loading = false;
                vm.sendSuccess = true;
            })
            .catch(function (error) {
                vm.loading = false;
                vm.sendSuccess = false;
                if(typeof error.response.data.errors !== 'undefined') {
                    Object.keys(error.response.data.errors).forEach(formName => {
                        error.response.data.errors[formName].forEach(errorMessage => {
                           vm.errors.push(errorMessage);
                        });
                    })
                }
            });
        },
        closeModal() {
            this.showFormModal = false;
        }
    }
}
</script>
<style lang="scss">
    ul.errors > li:first-letter {
        text-transform: uppercase;
    }
</style>
